export enum Role {
  Administrator = 'ADMIN',
  Subscriber = 'SUBSCRIBER',
  TechnicalAdmin = 'TECHNICAL_ADMIN',
  User = 'USER',
  WarehouseEmployee = 'WAREHOUSE_EMPLOYEE',
  WarehouseManager = 'WAREHOUSE_MANAGER',
}
